import PropTypes from "prop-types";

import { ProductCardPropType } from "./product-card";


export const RelatedProductsSectionPropType = PropTypes.shape({
    hidden_products_count: PropTypes.number,
    label: PropTypes.string.isRequired,
    product_slug: PropTypes.string,
    product_uid: PropTypes.string,
    related_products: PropTypes.arrayOf(ProductCardPropType),
    title: PropTypes.string.isRequired,
    view_more_url: PropTypes.string,
});

export const RelatedProductsAreaPropType = PropTypes.shape({
    sections: PropTypes.arrayOf(RelatedProductsSectionPropType).isRequired,
    has_in_stock: PropTypes.bool,
});
